//
//
//
//
//
//

export default {
  props: {
    title: {
      type: String,
      default: '正在载入...'
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/loading.vue